// observability.jsx|tsx
"use client"; // browser only: https://react.dev/reference/react/use-client
import { HoneycombWebSDK } from '@honeycombio/opentelemetry-web';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import React, { FC } from "react";
import ReactDOM from "react-dom";

const configDefaults = {
  ignoreNetworkEvents: true,
  // propagateTraceHeaderCorsUrls: [
  // /.+/g, // Regex to match your backend URLs. Update to the domains you wish to include.
  // ]
}

var apiKey = 'hcaik_01j29m4c523rth3v1veyntg2jeqejx60vcm6qck3re1cjyggn82stw10wn';
var serviceName = 'shopify-fender';

if(window.location.href.includes('aart') || window.location.href.includes('sandbox')){
  apiKey = 'hcaik_01j29ma53xs374cj87fgwtm6jp0pra15t47bydgzcxxajsgnaw15rhr0gr';
}

if(window.location.href.includes('qa') || window.location.href.includes('development') || window.location.href.includes('dev') || window.location.href.includes('garage')){
  apiKey = 'hcaik_01j29ma53xs374cj87fgwtm6jp0pra15t47bydgzcxxajsgnaw15rhr0gr';
}

if(window.location.href.includes('staging')){
  apiKey = 'hcaik_01j29ma53xs374cj87fgwtm6jp0pra15t47bydgzcxxajsgnaw15rhr0gr';
}

if(window.location.href && window.location.href.toLowerCase().includes('jackson')){
  serviceName = 'shopify-jackson';
}

if(window.location.href && window.location.href.toLowerCase().includes('presonus')){
  serviceName = 'shopify-presonus';
}

const Index: FC = () => {
  try {
    const sdk = new HoneycombWebSDK({
      // endpoint: "https://api.eu1.honeycomb.io/v1/traces", // Send to EU instance of Honeycomb. Defaults to sending to US instance.
      debug: true, // Set to false for production environment.
      apiKey: apiKey, // Replace with your Honeycomb Ingest API Key.
      serviceName: serviceName, // Replace with your application name. Honeycomb uses this string to find your dataset when we receive your data. When no matching dataset exists, we create a new one with this name if your API Key has the appropriate permissions.
      instrumentations: [getWebAutoInstrumentations({
        // Loads custom configuration for xml-http-request instrumentation.
        '@opentelemetry/instrumentation-xml-http-request': configDefaults,
        '@opentelemetry/instrumentation-fetch': configDefaults,
        '@opentelemetry/instrumentation-document-load': configDefaults,
      })],
    });
    sdk.start();
  } catch (e) {return null;}
  return null;
}

ReactDOM.render(<Index />, document.getElementById('react-honeycomb'));